import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLibrary",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, r, i, _, f, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--library"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Library",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...r[0] || (r[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .5-.5Zm5.863 1.02a.5.5 0 0 1 .618.343l2 7a.5.5 0 0 1-.962.274l-2-7a.5.5 0 0 1 .344-.618ZM6 2.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0V3a.5.5 0 0 1 .5-.5Zm-2 1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const h = /* @__PURE__ */ s(c, [["render", u]]);
export {
  h as default
};
//# sourceMappingURL=library.js.map
